<template>
  <div></div>
</template>

<script>
import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu,
  },
  props: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.loginNav {
  background-color: green;
  /* height: 40px; */
}
</style>
>
